import { ReactNode } from 'react';

import cls from './Caption.module.scss';

type Props = {
  children: ReactNode;
};

export const Caption = ({ children }: Props) => {
  return <div className={cls.caption}>{children}</div>;
};
